var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',_vm._g({on:{"click":function () {}}},_vm.$listeners),[_c('v-img',{class:{
          'v-image--hovered': hover
        },attrs:{"src":_vm.src,"height":"350"}}),_c('v-overlay',{attrs:{"opacity":.8,"value":hover,"absolute":"","z-index":"0"}},[_c('v-fade-transition',{attrs:{"appear":""}},[_c('v-icon',{attrs:{"size":"88","color":"#FFFFFFE6"}},[_vm._v(" mdi-fullscreen ")])],1)],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }